import React from "react";
import { Chart } from 'primereact/chart';

export default function expenseByTruck(props){
    var chartData = {
        labels: props?.trucks?.map(truck => truck.plate),
        datasets: [
            {
                label: "Faturamento Bruto",
                backgroundColor: '#42A5F5',
                data: props?.trucks?.map(truck => truck.amount)
            },
            {
                label: "Despesa",
                backgroundColor: '#FFA726',
                data: props?.trucks?.map(truck => truck.expense)
            }
        ]
    }

    let chartOptions = {
        maintainAspectRatio: false,
        aspectRatio: .8,
        plugins: {
            legend: {
                labels: {
                    color: '#495057'
                }
            }
        },
        scales: {
            x: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            },
            y: {
                ticks: {
                    color: '#495057'
                },
                grid: {
                    color: '#ebedef'
                }
            }
        }
    };

    return (
        <>
            <div className="col-12 xl:col-12">
                <div className="card">
                    <div className="flex justify-content-between align-items-center mb-5">
                        <h5>Faturamento Bruto x Despesa <br /><small style={{ fontSize: 10 }}>Agrupado por Caminhão</small></h5>
                    </div>
                    <Chart type="bar" data={chartData} options={chartOptions} />
                </div>
            </div>
            
        </>
    )
}